
import * as Yup from "yup";

const USER = {
    firtsName: "",
    lastName: "",
    userName: "",
    email: "",
    password: "",
    phoneNumber: "",
    position: "",
    address: "",
    organizationId: "",
    roles: []
}
const phoneRegExp = /^(\+\d{1,4})?([ -]?\d{2,4}){2,}$/;

const TODIS_USERS = Yup.object().shape({
    firstName: Yup.string('Value should be a text').required('Required'),
    lastName: Yup.string().required('Lastname is required'),
    userName: Yup.string().required('Username is required'),
    email: Yup.string().email('Not a proper email').required('Email is required'),
    password: Yup.string().required('Password is required'),
    phNo: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required('Phone Number is required'),
    position: Yup.string().required('Position is required'),
    address: Yup.string().required('Address is required'),
    organizationId: Yup.string().required('Organization is required'),
    roles: Yup.array().min(1, "Choose at least 1 Role").required("Role is required")
});

const ROLE = {
    roleName: "",
    description: "",
    permissions: []
}
const TODIS_ROLES = Yup.object().shape({
    roleName: Yup.string().max(20, "Role name must be at most 20 characters").required('Role name is required'),
    description: Yup.string().max(500, "Description must be at most 500 characters").required('Description is required'),
    permissions: Yup.array().min(1, "Select at least one permission to Role").required("Permissions is required") 
});

const ORGANIZATION = {
    name: "",
    description: "",
    regionalPartners: [],
    roles: []
}
const TODIS_ORGANIZATION = Yup.object().shape({
    name: Yup.string().required('Organization name is required'),
    description: Yup.string().required('Description is required'),
    regionalPartners: Yup.array().min(1, "Choose at least 1 Regional Partner").required("Role is required"),
    roles: Yup.array().min(1, "Choose at least 1 Role").required("Role is required")
});

export { USER, ROLE, ORGANIZATION, TODIS_USERS, TODIS_ROLES, TODIS_ORGANIZATION };